const SUPERSCRIPT = { 0: '⁰', 1: '¹', 2: '²', 3: '³', 4: '⁴', 5: '⁵', 6: '⁶', 7: '⁷', 8: '⁸', 9: '⁹', '-': '⁻', '+': '⁺' };

function formatPlain(text) {
  return text
    .replace(/(\d)\s*\*\s*(\d)/g, '$1 × $2')
    .replace(/\^\{?([+-]?\d+)\}?/g, (_, power) => [...power].map((char) => SUPERSCRIPT[char] ?? char).join(''))
    .replace(/<=/g, '≤')
    .replace(/>=/g, '≥')
    .replace(/!=/g, '≠');
}

export function formatMath(text) {
  if (typeof text !== 'string') return '';
  return text
    .split(/(`[^`]*`)/g)
    .map((part) => (part.startsWith('`') && part.endsWith('`') ? part : formatPlain(part)))
    .join('');
}

export function parseDescription(description) {
  let value = description;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch {
      return { blocks: [{ text: value }], examples: [], constraints: [] };
    }
  }
  if (Array.isArray(value)) return { blocks: value, examples: [], constraints: [] };
  if (!value || typeof value !== 'object') return { blocks: [], examples: [], constraints: [] };
  return {
    blocks: Array.isArray(value.content) ? value.content : [],
    examples: Array.isArray(value.examples) ? value.examples : [],
    constraints: Array.isArray(value.constraints) ? value.constraints : [],
  };
}

export const asText = (value) => (typeof value === 'string' ? value : JSON.stringify(value));
